import { Injectable } from '@angular/core';

declare const firebase:any;

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {



  constructor() {

  }

  InitializeFirebase()
  {
  var firebaseConfig =
  {apiKey: "AIzaSyBR92iAb_o0_SkLV3wk60L4v6xn4Rv8aJw",
  authDomain: "roshan-digital-account-ce9db.firebaseapp.com",
  projectId: "roshan-digital-account-ce9db",
  storageBucket: "roshan-digital-account-ce9db.appspot.com",
  messagingSenderId: "754244311889",
  appId: "1:754244311889:web:996ba9ae6543599c5a5170",
  measurementId: "G-WEPR0XK1JF"};// Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();
  }

  logEvent(event)
  {
    firebase.analytics().logEvent(event);
  }

  setUserProp(event)
  {
    firebase.analytics().setUserProperties(event);
  }

}
